
















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DialogAction extends Vue {

    @Prop(Boolean) show!: boolean
    @Prop(String) title!: string
    @Prop(String) text!: string
    // @ts-ignore don't complain that it is not set
    @Prop(String) destination: string // this has to be set to the route name!

    seePending() {
        this.$router.push({ name: this.destination, params: { network: this.$route.params.network } })
        this.$emit('input')
    }

    reloadPage() {
        window.location.reload()
    }
}
